import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { DashboardComponent } from "src/app/sections/dashboard/dashboard.component";
// import { LynxFrontSwhcComponent } from "../../../../lynx-front-swhc/projects/lynx-front-swhc/src/lib/lynx-front-swhc.component"
import { Swhc3dComponent } from "src/app/components/swhc3d/swhc3d.component";
const routes: Routes = [
  { path: "", component: Swhc3dComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class Swhc3DRoutingModule {}
